import { render, staticRenderFns } from "./HyperacuteReview.vue?vue&type=template&id=0a13febb&"
import script from "./HyperacuteReview.vue?vue&type=script&lang=ts&"
export * from "./HyperacuteReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a13febb')) {
      api.createRecord('0a13febb', component.options)
    } else {
      api.reload('0a13febb', component.options)
    }
    module.hot.accept("./HyperacuteReview.vue?vue&type=template&id=0a13febb&", function () {
      api.rerender('0a13febb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/HyperacuteReview.vue"
export default component.exports